import { createAppSlice } from '!core/redux';

const initialState = {
  active: false,
};

export const insertOrderPrimarySlice = createAppSlice({
  name: 'insertOrderPrimarySlice',
  initialState,
  reducers: {
    insertOrderPrimaryActive: (state) => {
      state.active = true;
    },
    insertOrderPrimaryInactive: (state) => {
      state.active = false;
    },
  },
});
